// Conversion entre heures décimales (stockage en base) et affichage HH:MM
// Format cohérent avec la saisie "pointage" (FicheAffaireView.vue) : ex. "1:30"

export function formatDureeHHMM(decimalHeures) {
  const val = parseFloat(decimalHeures) || 0;
  const totalMinutes = Math.round(val * 60);
  const signe = totalMinutes < 0 ? '-' : '';
  const abs = Math.abs(totalMinutes);
  const heures = Math.floor(abs / 60);
  const minutes = abs % 60;
  return `${signe}${heures}:${String(minutes).padStart(2, '0')}`;
}

export function heuresMinutesToDecimal(heures, minutes) {
  const h = parseInt(heures, 10) || 0;
  const m = parseInt(minutes, 10) || 0;
  return +(h + m / 60).toFixed(4);
}

export function decimalToHeuresMinutes(decimalHeures) {
  const val = parseFloat(decimalHeures) || 0;
  const totalMinutes = Math.round(val * 60);
  return {
    heures: Math.floor(totalMinutes / 60),
    minutes: totalMinutes % 60,
  };
}
